import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="select3"
// Used in two filter form partials: assoc and enum
// Purpose: Filter available filter options by search input
// Explanation: select3 is supposed to replicated manually the functinality of the select2 gem
export default class extends Controller {
  static targets = [
    'input', // user search input
    'option', // select options
  ];

  connect() {
    console.log('select3 controller connected');
  }
  search() {
    // on input -> hide option targets that do not match the search input, show option targets that do match search input
    this.optionTargets.map((x) => {
      if (
        !x.innerText
          .toLowerCase()
          .includes(this.inputTarget.value.toLowerCase())
      )
        x.classList.add('hidden');
      if (
        x.innerText.toLowerCase().includes(this.inputTarget.value.toLowerCase())
      )
        x.classList.remove('hidden');
    });
  }
}
